"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLanguageByIP = exports.getIpAddress = void 0;
var constants_1 = require("../constants");
function getLanguageFromCountryCode(countryCode) {
    var cc = countryCode || "US";
    switch (cc.toUpperCase()) {
        case "IR": // Iran
        case "AF": // Afghanistan
        case "TJ": // Tajikistan
        case "UZ": // Uzbekistan
            return constants_1.LanguageIds.fa;
        case "SA": // Saudi Arabia
        case "EG": // Egypt
        case "DZ": // Algeria
        case "SD": // Sudan
        case "IQ": // Iraq
        case "MA": // Morocco
        case "YE": // Yemen
        case "SY": // Syrian Arab Republic
        case "TN": // Tunisia
        case "JO": // Jordan
        case "AE": // United Arab Emirates
        case "LB": // Lebanon
        case "LY": // Libya
        case "PS": // Palestine
        case "OM": // Oman
        case "KW": // Kuwait
        case "MR": // Mauritania
        case "QA": // Qatar
        case "BH": // Bahrain
        case "DJ": // Djibouti
        case "KM": // Comoros
            return constants_1.LanguageIds.ar;
        default:
            return constants_1.LanguageIds.en;
    }
}
function getJsonFromHttp(url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState != 4)
                return;
            if (this.status == 200) {
                var data = JSON.parse(this.responseText);
                resolve(data);
            }
            reject(this.status);
        };
        xhr.open("GET", url, true);
        xhr.send();
    });
}
function getIpAddress() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getJsonFromHttp(constants_1.LanguageDetectorApi.ApiPath)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data[constants_1.LanguageDetectorApi.IpAddressField]];
            }
        });
    });
}
exports.getIpAddress = getIpAddress;
function getUserLanguageByIP() {
    return __awaiter(this, void 0, void 0, function () {
        var userLanguage, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userLanguage = constants_1.LanguageIds.en;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getJsonFromHttp(constants_1.LanguageDetectorApi.ApiPath)];
                case 2:
                    data = _a.sent();
                    userLanguage = getLanguageFromCountryCode(data[constants_1.LanguageDetectorApi.CountryCodeField]);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    userLanguage = constants_1.LanguageIds.en;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, userLanguage];
            }
        });
    });
}
exports.getUserLanguageByIP = getUserLanguageByIP;
//# sourceMappingURL=ip-language-detector.js.map